import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import LibraryListItems from '../../../../components/LibraryListItems';

class Library extends Component {
  render () {
    const trainingCourses = this.props.courses.filter(
      (c) => c.category === 'training'
    );
    const ibslCourses = this.props.courses.filter(
      (c) => c.category === 'ibsl'
    );
    const signatureCourses = this.props.courses.filter(
      (c) => c.category === 'signature'
    );
    const independentCourses = this.props.courses.filter(
      (c) => c.category === 'independent'
    );

    let links = [];
    if (this.props.courseType === 'tutored') {
      links = [
        <LibraryListItems key='1' courses={trainingCourses} heading='BSL Training Courses' postPend='Course' />,
        <LibraryListItems key='2' courses={ibslCourses} heading='IBSL Awards' />,
        <LibraryListItems key='3' courses={signatureCourses} heading='Signature Awards' />
      ];
    } else {
      links = [
        <LibraryListItems key='1' courses={independentCourses} heading='Independent Courses' />
      ];
    }
    return (
      <main className='main'>
        <Helmet>
          <title>British Sign Language Training and Qualification Courses Library - BSL Courses</title>
          <meta name='description' content='Choose from a range of online British Sign Language training course levels and learn with the help of your own personal one-to-one professional BSL teacher' />
        </Helmet>
        <div className='l-container'>
          <article className='course-library'>
            {links}
          </article>
        </div>
      </main>
    );
  }
}

Library.propTypes = {
  courses: PropTypes.array,
  courseType: PropTypes.string
};

export default Library;



// WEBPACK FOOTER //
// ./src/views/Main/Courses/Library/index.js